import { useEffect, useState } from "react";
import {
  CUBE_TIME_PERIOD_TO_CUSTOM_DATE,
  customDateToTimePeriod,
  filterModuleHasContent,
  parseCubeFiltersDocument,
  parseFilterModuleFiltersFromCubeFilters,
  timePeriodToCustomDate,
} from "../../helper/Quadrant/quadrantHelper";
import { processFields } from "./subComponents/filterHelper";
import {
  FiltersCampaignDataQuadrant,
  FiltersDimensionDataQuadrant,
  FiltersMeasuresDataQuadrant,
} from "./FilterData/quadrantFilter";

export {
  CUBE_TIME_PERIOD_TO_CUSTOM_DATE,
  customDateToTimePeriod,
  filterModuleHasContent,
  parseCubeFiltersDocument,
  parseFilterModuleFiltersFromCubeFilters,
  timePeriodToCustomDate,
};

/** Shared date presets (ProductSet / StopLoss / Campaign ABO). */
export const FILTER_LAST_7_14_DAYS_OPTIONS = [
  { value: "last_7d", label: "Last 7 days", type: "" },
  { value: "last_14d", label: "Last 14 days", type: "" },
];

export function getFilterConfigForCampaignAbo(userPlatform, topXConfig) {
  const platform = userPlatform || "amazon";
  return {
    campaigns: FiltersCampaignDataQuadrant[platform],
    measure: platform === "amazon" ? FiltersMeasuresDataQuadrant["amazonCampaignABO"] : FiltersMeasuresDataQuadrant[platform],
    dimension: FiltersDimensionDataQuadrant[platform],
    topXConfig,
  };
}

let cachedKey = null;
let cachedReady = false;
let bootstrapPromise = null;

/** Same processFields bootstrap used by ProductSetFilters / Campaign ABO. */
export async function bootstrapFilterQuadrantFields(clientId, userPlatform = "amazon") {
  if (!clientId) {
    cachedReady = true;
    return true;
  }

  const platform = userPlatform || "amazon";
  const key = `${clientId}_${platform}`;
  if (cachedKey === key && cachedReady) return true;
  if (cachedKey === key && bootstrapPromise) return bootstrapPromise;

  cachedKey = key;
  cachedReady = false;

  bootstrapPromise = (async () => {
    try {
      FiltersDimensionDataQuadrant[platform].fields = await processFields(
        FiltersDimensionDataQuadrant[platform].fields,
        clientId,
        []
      );
      FiltersMeasuresDataQuadrant[platform].fields = await processFields(
        FiltersMeasuresDataQuadrant[platform].fields,
        clientId,
        []
      );
      FiltersCampaignDataQuadrant[platform].fields = await processFields(
        FiltersCampaignDataQuadrant[platform].fields,
        clientId,
        []
      );
      cachedReady = true;
      return true;
    } catch {
      cachedReady = true;
      return false;
    } finally {
      bootstrapPromise = null;
    }
  })();

  return bootstrapPromise;
}

export function useFilterFieldsBootstrap(clientId, userPlatform = "amazon") {
  const [ready, setReady] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!clientId) {
      setReady(false);
      setLoading(false);
      return undefined;
    }

    let cancelled = false;
    setLoading(true);
    bootstrapFilterQuadrantFields(clientId, userPlatform).then(() => {
      if (!cancelled) {
        setReady(true);
        setLoading(false);
      }
    });

    return () => {
      cancelled = true;
    };
  }, [clientId, userPlatform]);

  return { ready, loading };
}
